import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import Loader from 'router/Loader';

const MaskBreakagePage = Loader(
  lazy(() => import('content/pages/Private/Hole')),
);

const MaskBreakageRouter: RouteObject[] = [
  {
    path: 'holes/:image_id',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <MaskBreakagePage />,
      },
    ],
  },
];

export default MaskBreakageRouter;
